export function exportSearchPdf() {
  document.body.classList.add('print-mode');
  // ensure DOM has applied the class before printing
  requestAnimationFrame(() => {
    window.print();
    // afterprint is more reliable than immediately removing
    window.addEventListener(
      'afterprint',
      () => document.body.classList.remove('print-mode'),
      { once: true }
    );
  });
}
